export default "__VITE_ASSET__DKiIkQq8__"